export default __webpack_public_path__ + "static/media/logo.9595f863.png";